<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 生産者管理
          p 生産者の追加/編集/削除ができます
          v-layout(row, justify-center)
          v-dialog(v-model='addDialog', persistent, max-width='600px')
            template(v-slot:activator='{ on }')
              v-btn(color='primary', depressed, v-on='on') 新規追加
            v-card
              v-card-title
                span.headline 生産者登録
              v-card-text
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(label='名前*', required='', v-model='producer.name')
                    img(:src="producer.imageUrl", height="100px", width="200px")
                    v-flex(xs12)
                      v-text-field(label='画像URL*', required='', v-model='producer.imageUrl')
                  small *indicates required field
              v-card-actions
                v-spacer
                v-btn(color='blue darken-1', flat='', @click='addDialog = false') Close
                v-btn(color='blue darken-1', flat='', @click='addProducer') Save
          v-data-table.elevation-1(:headers='headers', :items='data')
            template(v-slot:items='props')
              td.text-xs {{ props.item.id }}
              td.text-xs {{ props.item.name }}
              td
                img(:src="props.item.imageUrl", width="100px")
              td.text-xs
                v-layout(row)
                  v-dialog(v-model='props.item.updateDialog', persistent, max-width='600px')
                    template(v-slot:activator='{ on }')
                      v-btn(color='warning', small, depressed, v-on='on', @click='openEditDialog(props.index)') 編集
                    v-card
                      v-card-title
                        span.headline 生産者情報編集
                      v-card-text
                        v-container(grid-list-md)
                          v-layout(wrap)
                            v-flex(xs12)
                              v-text-field(label='名前*', required='', v-model='producer.name')
                            img(:src="producer.imageUrl", height="100px", width="200px")
                            v-flex(xs12)
                              v-text-field(label='画像URL*', required='', v-model='producer.imageUrl')
                          small *indicates required field
                      v-card-actions
                        v-spacer
                        v-btn(color='blue darken-1', flat='', @click='closeEditDialog(props.index)') Close
                        v-btn(color='blue darken-1', flat='', @click='updateProducer(props.index)') Save
                  v-dialog(v-model='props.item.deleteDialog', persistent, max-width='290')
                    template(v-slot:activator='{ on }')
                      v-btn(color='error', dark, small, v-on='on') 削除
                    v-card
                      v-card-title.headline 確認してください。
                      v-card-text ID: {{ props.item.id }}
                        br
                        | 本当に削除してもよろしいですか。削除をすると、元に戻すことはできません。
                      v-card-actions
                        v-spacer
                        v-btn(color='green darken-1', flat='', @click='props.item.deleteDialog = false') Cancel
                        v-btn(color='error darken-1', flat='', @click='deleteProducer(props.index)') Delete
</template>
<script>
import Vue from 'vue'
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'

export default {
  name: 'category',
  components: {
    EmMenu
  },
  data () {
    return {
      addDialog: false,
      producer: {},
      headers: [ // テーブルのヘッダーを構造的に定義
        { text: 'ID', align: 'left', value: 'id', sortable: false },
        { text: '名前', align: 'left', value: 'name', sortable: false },
        { text: '画像', align: 'left', value: 'imageUrl', sortable: false },
        { text: '', value: 'action', sortable: false }
      ],
      data: []
    }
  },
  computed: {
  },
  methods: {
    getProducerList () {
      API.GetProducerList().then(result => {
        this.data = []
        result.producers.forEach((data) => {
          this.data.push({
            id: data.id,
            name: data.name,
            imageUrl: data.image_url
          })
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    addProducer () {
      API.AddProducer({ param: this.getRequestParam() }).then(result => {
        alert('新しい生産者が追加されました.')
        this.getProducerList()
        this.addDialog = false
        this.producer = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    updateProducer (index) {
      API.UpdateProducer({ param: this.getRequestParam() }).then(result => {
        alert('ID: ' + this.data[index].id + 'が編集されました.')
        this.getProducerList()
        this.data[index].updateDialog = false
        this.producer = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    deleteProducer (index) {
      let id = this.data[index].id
      API.DeleteProducer({ param: { id: id } }).then(result => {
        alert('ID: ' + id + 'を削除しました.')
        this.getProducerList()
        this.data[index].deleteDialog = false
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    openEditDialog (index) {
      this.producer = Vue.util.extend({}, this.data[index])
    },
    closeEditDialog (index) {
      this.data[index].updateDialog = false
      this.producer = {}
    },
    getRequestParam () { // this.producerからAdd/Update用のリクエストパラメータを作成する
      return {
        id: this.producer.id,
        name: this.producer.name,
        image_url: this.producer.imageUrl
      }
    }
  },
  created () {
    this.getProducerList()
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
